const inventorySubTablePageFields = {
	page: {
		isGroupByModalVisible: false,
		isResetFiltersButtonVisible: false,
	},
};

export default inventorySubTablePageFields;
